import { LayoutProps } from 'components/atoms/Layout/interfaces'
import { InputBuildProps } from 'components/molecules/InputBuild/interfaces'
import { SelectBuildProps } from 'components/molecules/SelectBuild/interfaces'

interface Schema {
   id: 'uf' | 'periodoInicio' | 'periodoFim' | 'identificadorDebito'
}

interface FormDetranBillingReportInterface {
   input?: InputBuildProps & Schema
   select?: SelectBuildProps & Schema
   layout: LayoutProps
}

export const FormDetranBillingReportValue =
   (): FormDetranBillingReportInterface[] => [
      {
         select: {
            id: 'uf',
            label: 'UF',
            options: [
               { text: 'PR', value: 'PR' },
               { text: 'RN', value: 'RN' }
            ],
            defaultValue: 'PR',
         },
         layout: {
            type: 'col',
            layout: { base: 12, md: 2 }
         }
      },
      {
         input: {
            id: 'periodoInicio',
            label: 'Período Inicial',
            type: 'date'
         },
         layout: {
            type: 'col',
            layout: { base: 12, md: 2 }
         }
      },
      {
         input: {
            id: 'periodoFim',
            label: 'Período Final',
            type: 'date'
         },
         layout: {
            type: 'col',
            layout: { base: 12, md: 2 }
         }
      },
      {
         input: {
            id: 'identificadorDebito',
            label: 'Identificador do débito',
            type: 'number',
            min: 1,
            step: 1
         },
         layout: {
            type: 'col',
            layout: { base: 12, md: 3 }
         }
      }
   ]
